export enum WalletTabType {
    PIGGY_CLUB = 'PIGGY_CLUB',
    BUILDING = 'BUILDING',
    DICE_ROLLS = 'DICE_ROLLS',
    TOKENS = 'TOKENS'
}